/**
 * Emitted when the session expires.
 */
export interface SessionExpiredEvent {
  event: 'session-expired'
}

/** @inheritDoc */
export function SessionExpiredEvent(): SessionExpiredEvent {
  return { event: 'session-expired' }
}

/**
 * Emitted when the user has been successfully authenticated.
 */
export interface AuthenticatedEvent {
  event: 'authenticated'
}

/** @inheritDoc */
export function AuthenticatedEvent(): AuthenticatedEvent {
  return { event: 'authenticated' }
}

/**
 * Emitted when requesting to close the Taxfyle window.
 */
export interface ExitAction {
  action: 'exit'
}

/** @inheritDoc */
export function ExitAction(): ExitAction {
  return { action: 'exit' }
}

/**
 * Emitted when requesting to add an event to calendar.
 */
export interface AddToCalendarAction {
  action: 'add-to-calendar'
  icsDataUrl: string
}

/** @inheritDoc */
export function AddToCalendarAction(icsDataUrl: string): AddToCalendarAction {
  return { action: 'add-to-calendar', icsDataUrl }
}

/**
 * Emitted when requesting to download a document.
 */
export interface DownloadDocumentAction {
  action: 'download-document'
  downloadUrl: string
}

/** @inheritDoc */
export function DownloadDocumentAction(
  downloadUrl: string,
): DownloadDocumentAction {
  return { action: 'download-document', downloadUrl }
}

/**
 * Emitted when requesting to open an external URL.
 */
export interface OpenExternalUrlAction {
  action: 'open-external-url'
  url: string
}

/** @inheritDoc */
export function OpenExternalUrlAction(url: string): OpenExternalUrlAction {
  return { action: 'open-external-url', url }
}
